// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__Hc9_U","header":"Messages_header__1yKVS"};